import { ShopOutlined } from '@ant-design/icons'
import React from 'react'

import { AppHeader, ColumnLayout } from '@/components'

import { GameHubHeader } from './game-hub-header.component'
import GameHub from './game-hub.component'

export const GameHubContainer = () => {
  const header = <AppHeader title={<GameHubHeader />} avatar={<ShopOutlined style={{ fontSize: 24 }} />} />

  return <ColumnLayout header={header} middle={<GameHub />} />
}
